var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 211,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.052 211.001H22.948a23.08 23.08 0 01-8.782-1.736 22.953 22.953 0 01-7.445-4.944A22.73 22.73 0 010 188.196V32.462h222.052a23.023 23.023 0 0116.227 6.68A22.734 22.734 0 01245 55.265v132.93a22.733 22.733 0 01-6.721 16.125 23.023 23.023 0 01-16.227 6.68zM16.333 48.693v139.503c0 1.744.697 3.416 1.938 4.649a6.64 6.64 0 004.677 1.925h199.104a6.638 6.638 0 004.677-1.925 6.553 6.553 0 001.938-4.649V55.266a6.551 6.551 0 00-1.938-4.648 6.635 6.635 0 00-4.677-1.925H16.333z",
    fill: "#024EC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.73 48.693H0V22.805A22.732 22.732 0 016.721 6.68 23.022 23.022 0 0122.948 0H97.02a22.973 22.973 0 0112.098 3.368 22.77 22.77 0 018.482 9.211l18.13 36.114zM16.333 32.462h92.937l-6.37-12.579a6.59 6.59 0 00-2.42-2.653 6.645 6.645 0 00-3.46-.999H22.948a6.637 6.637 0 00-4.677 1.925 6.553 6.553 0 00-1.938 4.649v9.657z",
    fill: "#024EC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/files-icon.e58fa4a003c6526b1117744f20756086.svg";
export { ForwardRef as ReactComponent };